import { configureStore } from "@reduxjs/toolkit";
import appParamSlice from "./appParamSlice";
import slice from "./mainSlice";
import multipleEntryPassSlice from "./multipleEntryPassSlice";
import partnerSlice from "./partnerStore";
import userSlice from "./userSlice";
import homeCarouselsSlice from "../v2/store/homeCarouselsSlice";

export default configureStore({
  reducer: {
    mainSlice: slice,
    userSlice: userSlice,
    appParamSlice: appParamSlice,
    partnerSlice: partnerSlice,
    multipleEntryPassSlice: multipleEntryPassSlice,
    homeCarouselsSlice: homeCarouselsSlice,
  },
});
